import React, {Component} from 'react';
import actions from '../../../auth/actions';
import TopHeader from './../../components/layout/TopHeader';
import {connect} from 'react-redux';

class TopHeaderContainer extends Component {
    render() {
        const {
            userName, 
            path, 
            logout,
            topHeaderCustomTitle,
            customBreadcrumbs
        } = this.props;

        return (
            <TopHeader
                userName={userName}
                pageName={path}
                logout={logout}
                topHeaderCustomTitle={topHeaderCustomTitle}
                customBreadcrumbs={customBreadcrumbs}
            />
        );
    }
}

const mapStateToProps = ({
    authReducer,
    sharedReducer
}) => ({
    userName: authReducer.name,
    topHeaderCustomTitle: sharedReducer.topHeaderTitle,
    customBreadcrumbs: sharedReducer.breadcrumbs
})

const mapDispatchToProps = {
    logout: actions.logout
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TopHeaderContainer);